import React, { useState } from "react";
import {
	Container,
	Typography,
	TextField,
	Button,
	Box,
	Snackbar,
	Alert,
	Paper,
	CircularProgress,
} from "@mui/material";

const SuggestFeaturePage = () => {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		featureDescription: "",
	});
	const [submitting, setSubmitting] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState("");

	const handleChange = (field) => (e) => {
		setFormData((prev) => ({ ...prev, [field]: e.target.value }));
	};

	const handleSubmit = async () => {
		setSubmitting(true);
		setError("");
		// Simulate API call with timeout
		setTimeout(() => {
			// For demonstration, always succeed
			setSubmitting(false);
			setSuccess(true);
			setFormData({ name: "", email: "", featureDescription: "" });
		}, 1500);
	};

	return (
		<Box sx={{ minHeight: "100vh", py: 8 }}>
			<Container maxWidth="sm">
				{/* Title */}
				<Typography variant="h3" align="center" gutterBottom sx={{ mb: 2 }}>
					Suggest a Feature
				</Typography>
				{/* Subtitle */}
				<Typography
					variant="subtitle1"
					align="center"
					color="textSecondary"
					mb={4}>
					Help us improve! Share your ideas and feature requests.
				</Typography>
				{/* Form Card */}
				<Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3 }}>
					<Box
						component="form"
						noValidate
						autoComplete="off"
						sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
						<TextField
							label="Your Name"
							value={formData.name}
							onChange={handleChange("name")}
							fullWidth
							required
						/>
						<TextField
							label="Your Email"
							type="email"
							value={formData.email}
							onChange={handleChange("email")}
							fullWidth
							required
						/>
						<TextField
							label="Feature Description"
							multiline
							rows={4}
							value={formData.featureDescription}
							onChange={handleChange("featureDescription")}
							fullWidth
							required
						/>
						<Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
							<Button
								variant="contained"
								color="primary"
								onClick={handleSubmit}
								disabled={submitting}
								startIcon={submitting && <CircularProgress size={20} />}>
								{submitting ? "Submitting..." : "Submit"}
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>

			{/* Success Snackbar */}
			<Snackbar
				open={success}
				autoHideDuration={3000}
				onClose={() => setSuccess(false)}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}>
				<Alert severity="success" sx={{ width: "100%" }}>
					Thank you! Your feature suggestion has been received.
				</Alert>
			</Snackbar>

			{/* Error Snackbar (if needed) */}
			{/* Uncomment if you want to simulate errors */}
			{/* <Snackbar
        open={Boolean(error)}
        autoHideDuration={4000}
        onClose={() => setError('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar> */}
		</Box>
	);
};

export default SuggestFeaturePage;
